export class StoreBaseMethods {
  static copyData(data, target) {
    Object.keys(data || {}).forEach((key, i) => {
      target[key] = data[key];
    });
  }
}
